import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      setSent(true); // show same message regardless — don't reveal if email exists
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-base">
      <div className="card w-[400px] p-8 space-y-4">
        <div className="text-center mb-2">
          <div className="inline-flex items-center gap-2 mb-3">
            <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center font-bold text-white">Cr</div>
            <div className="text-lg font-semibold tracking-tight">Cros<span className="text-secondary-400">ova</span></div>
          </div>
          <h1 className="text-lg font-semibold">Forgot your password?</h1>
          <p className="text-xs text-white/40 mt-1">Enter your email and we'll send you a reset link</p>
        </div>

        {sent ? (
          <div className="space-y-4">
            <div className="bg-secondary-400/[0.08] border border-secondary-400/20 rounded-xl p-4 text-center">
              <p className="text-[13px] text-secondary-400 font-medium mb-1">Check your inbox</p>
              <p className="text-[12px] text-white/50">
                If an account exists for <strong className="text-white/70">{email}</strong>, we've sent a password reset link. It expires in 1 hour.
              </p>
            </div>
            <Link to="/login" className="block text-center text-[12px] text-white/30 hover:text-white/60 transition-colors">
              ← Back to login
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input
              className="input"
              placeholder="Email address"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" disabled={loading} className="btn-primary w-full">
              {loading ? 'Sending...' : 'Send reset link'}
            </button>
            <p className="text-xs text-white/40 text-center">
              <Link to="/login" className="text-primary-300">← Back to login</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
